// Exporting dependencies for testing
// File needed in order to resolve less styles
module.exports = {};

require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/node_modules/header/header.less');